export const BASE_URL = "https://lbparkinghero.com/api";
export const STATUS = {
    SUCCESS: "success",
    FAILURE: "failure"
};

export const gofundme = "https://gofund.me/ad8bcae3"
export const storeToParkingHero = "https://www.parkinghero.net/store-2-1"

export const Email_not_verified = {
    heading: "E-Mail Not Verified Popup Content",
    content: "You have not verified your E-Mail still.Please verify your email to continue Login",
    linkContent: "Click here to send verification Mail"
}

export const Mobile_not_verified = {
    heading: "(Mobile Number Not Verified Popup Content",
    content: "You have not verified your Mobile Number still.Please verify your mobile number to continue Login",
    linkContent: "Click here to send SMS Validation Message"
}

export const not_verified = {
    heading: "E-Mail and Mobile Number Not Verified Popup Content",
    content: "You have not verified your E-Mail and Mobile Number still.Please verify your mobile number and E-Mail to continue Login.",
    linkContent: "Click here to send verification Mail",
    MobileLinkContent: "Click here to send SMS Validation Message"
}

export const OPTIONS = {
    heading1: "Report misuse of Parking Hero",
    message1: "My Account has been misused by someone.Kindly block my account",
    heading2: "I am having problems with my account ",
    message2: "I am unable to login into my account",
    heading3: "I am having problems setting up my account ",
    message3: "I am not getting SMS,email in the registered Mail and Mobile Number while registering my Account.",
    heading4: "I would like to learn more about how I can use Parking Hero for my business ",
    message4: "Can you let me know the ways in which I can use Parking Hero for my Business",
    heading5: "Others",
    message5: "",

}

export const timeForAction_OPTIONS = {
    message1: "Street Sweeping",
    message2: "Expired Parking Meter",
    message3: "Car is being Towed ",
    message4: "Car is blocking path of travel",
    message5: "Car Interior/headlight left on",
    message6: "Accident*",
    message7: "Break-in*",
    message8: "Hit-and-Run*",
    message9: "Others",
}


